import api from "./api";

const balanceService = {
    getBalanceOfToken: (jwttoken, idActiveToken) =>
        api.get(`/balanceGpxcoin/${idActiveToken}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getBalanceOfGpx: (jwttoken) =>
        api.get(`/balanceGpxcoin`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default balanceService;